const CareerPathwaysUiPatterns = <template></template>;

export default CareerPathwaysUiPatterns;
